import { render } from "./ErequisitionView.vue?vue&type=template&id=d2735b3c"
import script from "./ErequisitionView.vue?vue&type=script&lang=js"
export * from "./ErequisitionView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/ErequisitionView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d2735b3c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d2735b3c', __exports__)) {
    console.log('reload')
    api.reload('d2735b3c', __exports__)
  }
  
  module.hot.accept("./ErequisitionView.vue?vue&type=template&id=d2735b3c", () => {
    console.log('re-render')
    api.rerender('d2735b3c', render)
  })

}


export default __exports__